var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-burger';
                    var viewUrl = 'sprite.svg#view-icon-burger';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 19',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };